export default __webpack_public_path__ + "tmp_src/components/ScrollTo/ScrollTo.css.liquid";